import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Button, Grid, Typography } from "components/controls/widget";
import { FormDecorated, FormResponse } from "common/api/Forms";
import VotingPage from "common/components/voting-forms/VotingPage";
import * as moment from "moment";


interface SeznamItemProps {
    item: FormDecorated;
    idtClena: number;
}

interface State {
    showDialog: boolean;
    completed: boolean;
    modified?: Date;
}

type PropsType = SeznamItemProps & WithStyles<typeof styles>;


class SeznamItem extends React.PureComponent<PropsType, State> {

    constructor(props: PropsType) {
        super(props);

        this.state = {
            showDialog: false,
            completed: props.item.completed,
            modified: props.item.modified,
        }
    }

    onClose = (formResp?: FormResponse) => {

        this.setState(state => {
            let completed = state.completed;
            let modified = state.modified;
            if (formResp !== undefined) {
                completed = formResp.completed;
                modified = formResp.modified;
            }
            return { showDialog: false, completed: completed, modified: modified }
        });
    }

    getDate = (date: Date) => {
        return moment(date).format('D. M. YYYY, HH.mm');
    }

    render() {
        const { item, classes, idtClena } = this.props;
        const { showDialog, completed, modified } = this.state;

        return <Grid container direction="column" className={classes.root} spacing={8}>
            <Grid item>
                <Typography variant="h6">{item.name}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="caption">{'Hlasování je otevřené do ' + this.getDate(item.openTo)}</Typography>
            </Grid>
            <Grid item>
                {completed ? <Grid container direction="row">
                    <Grid item className={classes.stateBoxCompleted}>{'Odesláno ' + this.getDate(modified)}</Grid>
                    <Grid item></Grid>
                    <Grid item></Grid>
                </Grid>
                    : <Grid container direction="row" spacing={8} alignItems="center" justify="space-between">
                        <Grid item><Button color="primary" variant="contained" onClick={() => this.setState({ showDialog: true })} >{'Upravit hlasování'}</Button></Grid>
                        <Grid item className={classes.stateBoxModified}>{modified ? 'Upraveno  ' + this.getDate(modified) : 'Dosud neupraveno'}</Grid>
                        <Grid item className={classes.stateBoxUnsended}>{'Dosud neodesláno'}</Grid>
                    </Grid>}
            </Grid>
            <VotingPage formSpec={item} idtClena={idtClena} show={showDialog} onClose={this.onClose} />
        </Grid>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        marginBottom: theme.spacing.unit,
        border: '1px solid silver',
        padding: theme.spacing.unit,
    },
    stateBoxCompleted: {
        color: theme.palette.success.main,
        fontWeight: 'bolder',
    },
    stateBoxModified: {
        color: theme.palette.primary.main,
        fontWeight: 'bolder',
    },
    stateBoxUnsended: {
        color: theme.palette.error.main,
        fontWeight: 'bolder',
    }


});

export default withStyles(styles)(SeznamItem);